import { Container, Row, Col, Button } from "react-bootstrap";
import { useState } from "react";
import { submitForm } from "../utils/submitForm";
import "./Collaboration.css";

const INITIAL_FORM_STATE = {
    companyName: "",
    location: "",
    headcount: "",
    details: "",
    phone: "",
    email: ""
};

/**
 * İşbirliği formu bileşeni.
 */
export default function Collaboration() {
    const [formData, setFormData] = useState({ ...INITIAL_FORM_STATE });

    /**
     * @param {import('react').FormEvent<HTMLFormElement>} event
     */
    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.target;

        if (!(form instanceof HTMLFormElement)) {
            return;
        }

        submitForm(form).then(
            () => {
                alert("Email gönderildi!");
                form.reset();
                setFormData({ ...INITIAL_FORM_STATE });
            },
            () => {
                alert("Email gönderilirken hata oluştu!");
            }
        );
    };

    /**
     * @param {import('react').ChangeEvent<HTMLInputElement | HTMLTextAreaElement>} event
     */
    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const messageValue =
        `Talep Türü: İşbirliği Formu\n` +
        `Firma Adı: ${formData.companyName}\n` +
        `Lokasyon: ${formData.location}\n` +
        `Kişi Sayısı: ${formData.headcount}\n` +
        `Detay Not: ${formData.details}`;

    return (
        <Container className="collaboration-container">
            <Row>
                <Col style={{ marginTop: '20px' }}>
                    <h1>Etkinlikleriniz BOAC’la daha tatlı</h1>
                    <p>Markanızda gerçekleşecek etkinliklerinizde BOAC yer alsın istiyorsanız aşağıdaki formuz doldurarak bizimle iletişime geçebilirsiniz.</p>
                    <form className="collaboration-form" onSubmit={handleSubmit}>
                        <label className="collaboration-label" htmlFor="companyName">Firma Adı</label>
                        <input
                            className="collaboration-input"
                            type="text"
                            id="companyName"
                            name="companyName"
                            value={formData.companyName}
                            onChange={handleChange}
                            required
                        />

                        <label className="collaboration-label" htmlFor="location">Lokasyon</label>
                        <input
                            className="collaboration-input"
                            type="text"
                            id="location"
                            name="location"
                            value={formData.location}
                            onChange={handleChange}
                            required
                        />

                        <label className="collaboration-label" htmlFor="headcount">Kişi Sayısı</label>
                        <input
                            className="collaboration-input"
                            type="number"
                            id="headcount"
                            name="headcount"
                            min="1"
                            value={formData.headcount}
                            onChange={handleChange}
                            required
                        />

                        <label className="collaboration-label" htmlFor="details">Detay Not</label>
                        <textarea
                            className="collaboration-input"
                            id="details"
                            name="details"
                            rows={4}
                            value={formData.details}
                            onChange={handleChange}
                            required
                        />

                        <label className="collaboration-label" htmlFor="phone">Numara</label>
                        <input
                            className="collaboration-input"
                            type="tel"
                            id="phone"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                        />

                        <input type="hidden" name="form_type" value="İşbirliği Formu" readOnly />
                        <input type="text" name="website" tabIndex={-1} autoComplete="off" aria-hidden="true" style={{ position: "absolute", left: "-9999px" }} />
                        <input type="hidden" name="name_from" value={formData.companyName} readOnly />
                        <input type="hidden" name="email_from" value={formData.email} readOnly />
                        <input type="hidden" name="phone_from" value={formData.phone} readOnly />
                        <textarea
                            style={{ display: "none" }}
                            name="message"
                            value={messageValue}
                            readOnly
                        />

                        <label className="collaboration-label" htmlFor="email">E-posta</label>
                        <input
                            className="collaboration-input"
                            type="email"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />

                        <div style={{ textAlign: 'center' }}>
                            <Button className="collaboration-submit-button" type="submit">Gönder</Button>
                        </div>
                    </form>
                </Col>
            </Row>
        </Container>
    );
}
